import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoginService } from 'src/app/services/login.service';
import { CommonService } from 'src/app/services/common.service';
import { AlertService } from 'src/app/services/alert.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  currentLanguage
  @Output() toggleSidebarForMe: EventEmitter<any> = new EventEmitter();
  lang: any = {};
  //Profile Login/Logout
  Profile = [
    {
      value: 1,
      label: 'My Profile',
    },
    {
      value: 2,
      label: 'Log out',
    },
  ];
  optionsLanguages = [];
  langCountryLabel: any;
  isMenuOpen: boolean = true;
  isMenuClose: boolean = false;
  userName: string;
  businessDate: any;
  disableBusinessDate=true;
  error=''
  constructor(
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private oauthService: OAuthService,
    private loginService: LoginService,
    private commonService: CommonService,
    private alertService: AlertService
  ) {
    this.commonService.dynamicLanguage.subscribe(data => {
      if (data) {
        this.getUnderwriterDate()
        this.commonService.updateQueueDashboard.emit(2);
        if (data.length != 0) {
          this.optionsLanguages = data
          this.currentLanguage = data[0].label;
          this.langCountryLabel = data[0].value;
          localStorage.setItem('language', data[0].value);
          this.translate.setDefaultLang(data[0].value);
          this.translate.use(data[0].value);
          this.commonService.loadhelpjson();
          this.commonService.dynamicLanguagelist([]);
        }
      }
    })
  }

  ngOnInit(): void {
    //inslization
  }
  toggleSidebar(event) {
    this.toggleSidebarForMe.emit();
    if (event == 'menu') {
      this.isMenuOpen = false;
      this.isMenuClose = true;
    } else {
      this.isMenuOpen = true;
      this.isMenuClose = false;
    }
  }
  redirectHome(event: any) {
    if (event) {
      this.router.navigate(['/home']);
    }
  }
  onSignOut() {
    console.log('Logout....');
    // OIDC enviroment (OKTA,o Auth0, etc....)
    if (this.PROFILE === this.ON_PREMISES) {
      this.doLogout(this.ON_PREMISES);
    }
    // Congito environment
    else if (this.PROFILE === this.ON_CLOUD) {
      this.doLogout(this.ON_CLOUD);
    }
    // CAS environment
    else if (this.PROFILE === this.ON_PREMISES_CAS) {
      this.doLogout(this.ON_PREMISES_CAS);
    }
  }

  checkUrl(): boolean {
    if (this.route.snapshot['_routerState'].url == '/dashboard') {
      document.getElementsByClassName('homeicon')[0].classList.add("hide-icon")
    } else {
      document.getElementsByClassName('homeicon')[0].classList.remove("hide-icon")
    }
    if (this.route.snapshot['_routerState'].url == '/dashboard') {
      return false;
    } else {
      return true;
    }
  }
  dataInput(event) {
    this.businessDate=event
    this.error=''
    let validate=this.commonService.datevalidation(event)
    if(validate){
    this.commonService.updateClaimOfficedate({ 'userBusinessDate': event, 'username': localStorage.getItem('userName') }).then((res) => {
      if (res) {
        if (res.message.status == 'SUCCESS') {
          this.commonService.showNotifyMessage('dateIsModified', 'success', 3000)
          this.getUnderwriterDate();
            this.commonService.updateQueueDashboard.emit(2);
        }else if(res.message.status == 'FAILURE' && res.message.details == undefined){
          this.commonService.showNotifyMessage(res.message.title, 'error', 3000)
        }else{
          this.commonService.showNotifyMessage(res.message.details[0], 'error', 3000)
        }
      }
    }).catch((err) => {
    });
   }else{
    this.error="Invalid Date"
   }
  }

  getUnderwriterDate() {
    if(this.loginService.userRoles){
      this.disableBusinessDate=this.loginService.userRoles.businessDateEnable=='Yes'?false:true;
    this.commonService.getClaimOfficeDate().then((res) => {
      this.businessDate = res.userBusinessDate
      localStorage.setItem('businessDate', this.businessDate);
      this.commonService.activateBusinessDate.emit(1);
    }).catch((err) => {
    });
  }
  }

  onChangeLanguage(item) {
    this.currentLanguage = item.label;
    this.langCountryLabel = item.value;
    this.translate.setDefaultLang(item.value);
    this.translate.use(item.value);
    localStorage.setItem('language', item.value);
    this.commonService.loadhelpjson()
  }

  onChange(event) { }
  doLogout(value) {
    if(!environment.SAME_DOMAIN){
      localStorage.clear();
      sessionStorage.clear();
     }
    let profile = value;
    // OIDC enviroment (OKTA,o Auth0, etc....)
    if (this.PROFILE === this.ON_PREMISES) {
      this.oauthService.logOut();
    }
    else if (profile == this.ON_CLOUD) {
      this.onCloudLogout();
    }
    // CAS environment
    else if (profile == this.ON_PREMISES_CAS) {
      this.onCASLogout();
    }
  }
  async onCloudLogout() {
    let singleAcess=false;
    let callapi=this.loginService.userRoles==undefined
     if(callapi){
      let res=await this.loginService.getUserRoles(localStorage.getItem('userName'));
      if(res){
        singleAcess=res.userRole.length == 1
      }
     }else{
      singleAcess=this.loginService.userRoles.userRole.length == 1
     }
      if (!singleAcess) {
        let logOut = environment.COGNITO.userProfileLogout;
        window.open(logOut, '_self');
      } else {
        let logOut = environment.COGNITO.logoutURL + "?client_id=" + environment.COGNITO.ClientId + "&logout_uri=" + environment.COGNITO.CAS_SERVER_URL + '?serviceurl=' + environment.COGNITO.landingLogout
        window.open(logOut, '_self');
      }
  }
  onCASLogout() {
    if(this.loginService.userRoles!= undefined){
      if (this.loginService.userRoles.userRole.length > 1) {
        let logOutUrl =
        environment.OAUTH2_CAS.landingLogout
      window.open(logOutUrl, '_self');
      } else {
        let logOutUrl = environment.OAUTH2_CAS.logoutURL;
        window.open(logOutUrl, '_self');
      }
    }
  }

  navigatetohome() {
    this.router.navigate(['/dashboard']);
  }
  getUserName() {
    let username = localStorage.getItem('profilename');
    if (username == undefined || username == null || username == '') {
      username = localStorage.getItem('userName')
    }
    return username;
  }
  profilename() {
    let username = localStorage.getItem('userName')
    return username;
  }
}
